import {
  APICallParams,
  APIInterfaceI,
  buildRequest,
  PaginationT,
} from '.';

class deviceProfiles implements APIInterfaceI {
  getAll = (pagination: PaginationT, params?: APICallParams) => (
    buildRequest('GET', `/scenarios/${params?.flowId}/device-profiles?list_req.cursor=${pagination.cursor}&list_req.limit=${pagination.limit}`)
  )

  getOne = (targetId: string, params?: APICallParams) => (
    buildRequest('GET', `/scenarios/${params?.flowId}/device-profiles/${targetId}`)
  )

  getIpFromIPNetwork = (flowId: string, deviceProfileId: string) => (
    buildRequest('GET', `/scenarios/${flowId}/device-profiles/${deviceProfileId}/get-ip-from-pool`)
  )

  register = (formData: any, params?: APICallParams) => (
    buildRequest('POST', `/scenarios/${params?.flowId}/device-profiles`, formData)
  )

  update = (targetId: string, formData: any, params?: APICallParams) => (
    buildRequest('PUT', `/scenarios/${params?.flowId}/device-profiles/${targetId}`, formData)
  )

  delete = (targetId: string, params?: APICallParams) => (
    buildRequest('DELETE', `/scenarios/${params?.flowId}/device-profiles/${targetId}`)
  )
}

export default deviceProfiles;
